var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGiftIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.665,
    height: 15.041,
    viewBox: "0 0 15.665 15.041",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "gift",
    transform: "translate(0 0.228)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_24192",
    "data-name": "Path 24192",
    d: "M14.152,4.578H11.807a2.387,2.387,0,0,0,.573-.393A2.585,2.585,0,1,0,8.723.53,4.338,4.338,0,0,0,7.844,2.5,4.338,4.338,0,0,0,6.964.53,2.585,2.585,0,1,0,3.307,4.183a2.373,2.373,0,0,0,.577.394H1.517A1.522,1.522,0,0,0,0,6.1v7.211a1.511,1.511,0,0,0,1.517,1.505H14.152a1.507,1.507,0,0,0,1.513-1.505V6.1A1.518,1.518,0,0,0,14.152,4.578ZM9.419,5.788V13.6H6.273V5.788ZM8.9,3.324A4.226,4.226,0,0,1,9.58,1.387,1.374,1.374,0,0,1,11.523,3.33a7.123,7.123,0,0,1-2.772.832C8.79,3.913,8.84,3.624,8.9,3.324ZM4.164,1.387a1.374,1.374,0,0,1,1.943,0,7.124,7.124,0,0,1,.832,2.772C6.691,4.12,6.4,4.07,6.1,4.009A4.227,4.227,0,0,1,4.164,3.33a1.374,1.374,0,0,1,0-1.943ZM1.211,13.308V6.1a.311.311,0,0,1,.307-.308H5.063V13.6H1.517A.3.3,0,0,1,1.211,13.308Zm13.244,0a.3.3,0,0,1-.3.295H10.63V5.788h3.522a.307.307,0,0,1,.3.308Z",
    transform: "translate(0)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGiftIcon);
export default __webpack_public_path__ + "static/media/gift-icon.8d2663b7ac9da5de51050b59033a3e1f.svg";
export { ForwardRef as ReactComponent };